// extracted by mini-css-extract-plugin
module.exports = {"separator":"CheckboxGroup_separator__1XqpF"};